import { MEDIA_QUERIES } from "@constants"
import styled, { keyframes } from "styled-components"

const EntranceAnimation = keyframes`
  0% {
    translate: -100%;
    opacity: 0;
  }
  100% {
    translate: 0;
    opacity: 1;
  }
`

export const PostBookNavNAV = styled.nav`
  left: 0;
  max-width: var(--PostBookNav--max-width);
  padding: var(--spacing--L) 0 var(--spacing--XL);
  position: relative;
  z-index: 5;

  ul,
  li,
  a {
    margin: 0;
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: var(--spacing--base-1);

    ul {
      gap: var(--spacing--base-0-5);
      margin-top: var(--spacing--base-1);
    }
  }

  > ul {
    max-width: var(--PostBookNav--max-width);
    padding-left: var(--spacing--base-3);
    position: sticky;
    top: calc(var(--spacing--M) + var(--PostBook--progress-bar-height));

    .is-static& {
      position: static;
    }

    > li > a {
      position: relative;

      &::before {
        background-color: var(--PostBook--text-color);
        content: "";
        display: block;
        height: 1px;
        opacity: 0.3;
        position: absolute;
        right: calc(100% + 1.5em);
        top: calc(var(--font-size--S) * var(--line-height--relaxed) / 2);
        width: var(--spacing--base-3);
      }

      &.is-active::before {
        opacity: 1;
      }
    }
  }

  a {
    color: var(--PostBook--text-color);
    display: block;
    margin: 0;
    opacity: 0.6;
    position: relative;
    transition: opacity 0.3s;
    text-wrap: balance;

    span {
      display: block;
      position: absolute;
      top: 0;
      right: calc(100% + 0.2em);
    }

    &:hover {
      opacity: 1;
    }

    &.is-active {
      opacity: 1;
      font-weight: var(--font-weight--medium);

      &.PostBookNav--section-link::before {
        content: "•";
        margin-right: 0.5em;
      }
    }
  }

  /* Entrance animation */
  &:not(.is-static) {
    > ul > li,
    > ul > li > ul > li {
      translate: -100%;
      opacity: 0;
    }

    &.is-ready {
      > ul > li,
      > ul > li > ul > li {
        animation: ${EntranceAnimation} 0.5s forwards;
      }

      > ul > li {
        ${Array(20).fill(null).map((_, i) => `
          &:nth-child(${i + 1}) {
            animation-delay: ${i * 50}ms;
          }
        `)}
      }

      > ul > li > ul > li {
        ${Array(20).fill(null).map((_, i) => `
          &:nth-child(${i + 1}) {
            animation-delay: ${100 + i * 25}ms;
          }
        `)}
      }
    }
  }

  &.is-static {
    --PostBookNav--max-width: none;

    background: var(--color--clay-100);
    border-radius: var(--border-radius--M);
    border: 0.5px solid var(--color--clay-300);
    box-shadow: var(--elevation--XS);
    margin: var(--spacing--L) auto;
    max-width: min(var(--container-width), var(--text-max-width));
    padding: var(--spacing--M);

    h2 {
      margin-bottom: var(--spacing--XS);
    }

    > ul {
      gap: var(--spacing--base-0-75);
      padding: 0;

      > li > a {
        font-size: var(--font-size--M);
        color: var(--color--text-default);

        span {
          display: inline-block;
          position: static;
        }

        &::before {
          display: none;
        }

        &.is-active {
          color: var(--color--text-dark);
        }
      }
    }

    ${MEDIA_QUERIES.L} {
      display: none;
    }
  }
`
